var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m512 177.52c0 106.45-101.57 173.29-246.12 299.77-2.83 2.47-6.35 3.71-9.87 3.71-3.53 0-7.06-1.23-9.89-3.71-144.42-126.37-246.12-193.31-246.12-299.77 0-80.52 57.4-146.52 136-146.52 54.54 0 95.02 33.5 120 81.02 0-.01.01-.01.01-.02 24.98-47.51 65.45-81 119.99-81 78.61 0 136 66.01 136 146.52z",
    fill: "#ff6a4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 177.52c0 106.45-101.57 173.29-246.12 299.77-2.83 2.47-6.35 3.71-9.87 3.71v-369c24.98-47.51 65.45-81 119.99-81 78.61 0 136 66.01 136 146.52z",
    fill: "#f03800"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.a2c65fae6f4bda3bd1b7eaaf9100a34b.svg";
export { ForwardRef as ReactComponent };